/**
 * Estado del carrito compartido por tier-discount.js y cart-goals.js.
 *
 * Lee /cart.js y avisa a los suscriptores cada vez que algo modifica el
 * carrito (carrito Vue, quick add, form de PDP), interceptando los fetch a
 * /cart/*.js. Los regalos agregados por el tema no cuentan para unidades ni
 * para el monto.
 */
(() => {
  if (window.TCLCartWatch) return;

  const originalFetch = window.fetch.bind(window);
  const listeners = new Set();

  const isGift = (item) => {
    const props = item.properties || {};
    return !!(props._isGift || props._isGiftMulti);
  };

  const watch = {
    cart: null,
    fetch: originalFetch,
    isGift,
    units: (cart) => cart.items.reduce((total, item) => (isGift(item) ? total : total + item.quantity), 0),
    // En centavos, con descuentos aplicados.
    amount: (cart) =>
      cart.items.reduce((total, item) => (isGift(item) ? total - item.final_line_price : total), cart.total_price),
    subscribe(fn) {
      listeners.add(fn);
      if (watch.cart) fn(watch.cart);
      return () => listeners.delete(fn);
    },
    refresh,
  };

  const publish = (cart) => {
    watch.cart = cart;
    listeners.forEach((fn) => fn(cart));
  };

  let refreshTimer;
  function refresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(async () => {
      try {
        const res = await originalFetch('/cart.js', { headers: { Accept: 'application/json' } });
        if (res.ok) publish(await res.json());
      } catch (e) {
        /* sin conexión: se mantiene el último estado */
      }
    }, 150);
  }

  const CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
  window.fetch = function (...args) {
    const request = originalFetch(...args);
    const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
    if (CART_MUTATION.test(url)) request.then(refresh, refresh);
    return request;
  };

  // El carrito Vue manda el carrito completo en el evento; el resto no.
  document.addEventListener('CART::UPDATED', (e) => {
    if (e.detail?.cart?.items) publish(e.detail.cart);
    else refresh();
  });
  window.addEventListener('pageshow', (e) => e.persisted && refresh());

  window.TCLCartWatch = watch;
  refresh();
})();
